import { ButtonLink } from '../ui/Button'
import { Card, SectionTitle } from '../ui/Card'

export function QuickLinksWidget() {
  return (
    <Card>
      <SectionTitle>Quick Links</SectionTitle>
      <div className="flex gap-3 flex-wrap">
        <ButtonLink to="/admin/users">Manage Users</ButtonLink>
        <ButtonLink to="/admin/staff-applications" variant="outline">Staff Applications</ButtonLink>
        <ButtonLink to="/admin/organizations" variant="outline">Organisations</ButtonLink>
        <ButtonLink to="/admin/practices" variant="outline">Practices</ButtonLink>
        <ButtonLink to="/clients" variant="outline">View Clients</ButtonLink>
      </div>
    </Card>
  )
}
